import { ProcessStatus } from '@/modules/api';

const OPEN_STATUSES: ProcessStatus[] = ['DRAFT', 'DECISION', 'EXAMINATION', 'EXECUTION', 'FINALIZATION'];

export function isProcessOpen(status: ProcessStatus) {
  return OPEN_STATUSES.includes(status);
}
